import HeaderBar from "../students/components/headerBar";
import Overview from "./overview";

const VerificationDashboard = () => {
  return (
    <section className="cht-animate-in cht-fade-in cht-duration-700">
      <HeaderBar pageHeader="Verification Center" />
      <main className="cht-container cht-mx-auto">
        <section className="cht-mb-12">
          <Overview />
        </section>
      </main>
    </section>
  );
};

export default VerificationDashboard;
